// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* ------------------------------------------------------------------------------------------ */
/* Based on the "Color Tokens" view -------------------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const colors: Styleguide["colors"] = {
    primary: {
        main: "#461E96", // Primary -> Main
        contrast: "#ffffff", // None, look at primary button text color
        light: "#DDDBF7", // Primary -> Light
        dark: "#211359", // Primary -> Dark
    },
    secondary: {
        main: "#00B4E6", // Secondary -> Main
        contrast: "#461E96", // None, look at secondary button text color
        light: "#80DEFF", // Secondary -> Light
        dark: "#062239", // Secondary -> Dark
    },
    tertiary: {
        main: "#E600BC", // Tertiary -> Main
        contrast: "#461E96", // None, look at tertiary button text color
        light: "#FED0E2", // Tertiary -> Light
        dark: "#430428", // Tertiary -> Dark
    },
    common: {
        border: "#CACACA", // Base Color -> Border
        borderLight: "#F5F5F5", // Black & White -> Border Light
        borderDark: "#8A8A8A", // Base Color -> Border Dark
        accent: "#F5F5F5", // Gray Shades -> Light
        accentContrast: "#3B3B3B", // Text Color -> Main
        accentContrastLight: "#6E6E6E", // Gray Shades -> Main
        background: "#ffffff", // None, look at website background color
        backgroundContrast: "#3B3B3B", // Text Color -> Main
        disabled: "#F5F5F5", // Gray Shades -> Light
        disabledDark: "#E8E8E8", // Gray Shades -> Mid
    },
    text: {
        main: "#3B3B3B", // Text Color -> Main
        accent: "#1E1E1E", // Text Color -> Accent
        disabled: "#6E6E6E", // Gray Shades -> Main
        link: "#461E96", // Primary -> Main
        linkHover: "#461E96", // Primary -> Dark
        linkAlt: "#3B3B3B", // Text Color -> Main
        linkAltHover: "#3B3B3B", // Primary -> Main
        input: "#3B3B3B", // Text Color -> Main
    },
    success: {
        main: "#007F50", // Alerts/Contrast -> Success
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Success" token
        light: "#007F50", // Alerts/Light -> Success
    },
    warning: {
        main: "#FAEB1E", // Alerts/Contrast -> Warning
        contrast: "#3B3B3B", // None, look at text color for the "Alerts/Contrast -> Warning" token
        light: "#FAEB1E", // Alerts/Light -> Warning
    },
    danger: {
        main: "#E22F00", // Alerts/Contrast -> Error
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Error" token
        light: "#E22F00", // Alerts/Light -> Error
    },
    info: {
        main: "#3B3B3B", // Alerts/Contrast -> Info
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Info" token
        light: "#3B3B3B", // Alerts/Light -> Info
    },
    neutral: {
        main: "#3B3B3B", // None
        contrast: "#3B3B3B", // None
        light: "#e8e8e8", // None
    },
    invert: {
        main: "#ffffff", // None
        contrast: "#461E96", // Primary -> Main
        hover: "#211359", // Primary -> Dark
        dark: "#ffffff",
    },
    placeholder: {
        main: "#b0b0b0",
        disabled: "6E6E6E",
    },
    button: {
        disabled: {
            main: "#d6d7dc", // Gray Shades -> Mid
            contrast: "#ffffff", // Black & White -> White
        },
    },
    header: {
        main: "#ffffff", // None, look at header background color
        contrast: "#272c37", // Text Color -> Main
        hover: "#211359", // Primary -> Dark
        accent: "#461E96", // Primary -> Main
        accentHover: "#211359", // Primary -> Dark
        accentContrast: "#ffffff", // None, should match "primary.contrast"
    },
    menu: {
        mainNavigation: {
            main: "#ffffff", // None, look at main navigation background color
            contrast: "#3B3B3B", // Text Color -> Main
            hover: "#461E96", // Primary -> Main
            underline: "#461E96", // Primary -> Main
            accent: "#461E96", // Primary -> Main
            accentContrast: "#ffffff", // None, should match "primary.contrast"
            accentHover: "#461E96", // Primary -> Main
            separator: "#E8E8E8", // Black & White -> Border
            border: "#E8E8E8", // Black & White -> Border
        },
        secondaryNavigation: {
            main: "#461E96", // Primary -> Main
            contrast: "#ffffff", // None, should match "primary.contrast"
            hover: "#ffffff", // None, should match "primary.contrast"
        },
    },
    footer: {
        main: "#F5F5F5", // Gray Shades -> Light
        contrast: "#3B3B3B", // Text Color -> Main
        alt: "#461E96", // Primary -> Main
        altContrast: "#ffffff", // None, should match "primary.contrast"
    },
    swatch: {
        main: "#E8E8E8", // Black & White -> Border
        contrast: "#3B3B3B", // Text Color -> Main
        hover: "#461E96", // Primary -> Main
        selected: "#461E96", // Primary -> Main
        selectedHover: "#211359", // Primary -> Dark
    },
};

export default colors;
